import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withRouter from 'react-router/withRouter';
import { get } from 'lodash';
import loadData from './innovation_by_design_page_state_manager';

import loadable from '@loadable/component';

const NotFound = loadable(() =>
  import('../../../../components/not_found_component/not_found_component')
);
const FuturePage = loadable(() => import('./innovation_by_design_future_page'));
const FranchisePage = loadable(() =>
  import('./innovation_by_design_page_franchise')
);

const FranchisePage2023 = loadable(() =>
  import('./innovation_by_design_page_franchise_2023')
);

const customFranchisePages = {
  'ibd-2023': FranchisePage2023,
  'ibd-2022-2': FranchisePage
};

const ibdPageController = ({ innovationByDesign, franchisePage, status }) => {
  const legacyDataObj = get(innovationByDesign, 'data', {});
  const franchiseDataObj = get(franchisePage, 'data', {});
  const franchiseCategory = get(
    franchiseDataObj,
    'franchiseCategory',
    undefined
  );
  const isCustomFranchisePage = customFranchisePages[franchiseCategory];

  if (isCustomFranchisePage) {
    const CustomFranchisePage = isCustomFranchisePage;

    return <CustomFranchisePage franchisePage={franchisePage} />;
  }

  // Handle with data from innovationByDesign store
  if (Object.keys(legacyDataObj).length > 0) {
    return (
      <FuturePage
        innovationByDesign={innovationByDesign}
        franchisePage={franchisePage}
        status={status}
      />
    );
  }

  // Handle with data from franchisePage store
  if (Object.keys(franchiseDataObj).length > 0) {
    return <FranchisePage franchisePage={franchisePage} />;
  }

  // Handle not found
  return (
    <section className="ibd-page">
      <article className="ibd-page__main--error-pg">
        <NotFound />
      </article>
    </section>
  );
};

ibdPageController.loadData = store => loadData(store);

function mapStateToProps(state = {}) {
  const ibdData = get(state, 'innovationByDesign.data', {});
  return {
    status: state.status.code,
    innovationByDesign: state.innovationByDesign,
    innovationByDesignPage: ibdData || {},
    franchisePage: state.franchisePage || {},
    config: state.config
  };
}

ibdPageController.propTypes = {
  innovationByDesign: PropTypes.shape({}).isRequired,
  franchisePage: PropTypes.shape({}),
  status: PropTypes.string || PropTypes.number
};

ibdPageController.defaultProps = {
  franchisePage: {},
  status: undefined
};

export default withRouter(connect(mapStateToProps)(ibdPageController));
